<template>
    <div>
        <div class="hero _fixed bg-secondary">
            <div class="hero-content text-center">
                <h1 class="text-white">{{ $t('General Terms and Conditions of the Lendlord') }}</h1>
            </div>
        </div>

        <div class="section">
            <div class="container">
                <div class="numbered" v-scroll-reveal>
                    <span class="_number">1</span>
                    <p v-html="$t('terms.item-1')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">2</span>
                    <p v-html="$t('terms.item-2')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">3.</span>
                    <p v-html="$t('terms.item-3')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">4</span>
                    <p v-html="$t('terms.item-4')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">5</span>
                    <p v-html="$t('terms.item-5')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">6</span>
                    <p v-html="$t('terms.item-6')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">7</span>
                    <p v-html="$t('terms.item-7')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">8</span>
                    <p v-html="$t('terms.item-8')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">9</span>
                    <p v-html="$t('terms.item-9')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">10</span>
                    <p v-html="$t('terms.item-10')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">11</span>
                    <p v-html="$t('terms.item-11')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">12</span>
                    <p v-html="$t('terms.item-12')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">13</span>
                    <p v-html="$t('terms.item-13')"></p>
                </div>

                <div class="numbered" v-scroll-reveal>
                    <span class="_number">14</span>
                    <p v-html="$t('terms.item-14')"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>
